module.exports = __webpack_public_path__ + "img/水白底.b6009b31.jpg";